import React from "react";
import { useTranslation } from "react-i18next";

const STATION_IMAGE_BASE_URL =
  "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/";

export function StationDetailsModal({ station, onClose }) {
  const { t } = useTranslation();

  if (!station) {
    return null;
  }
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 10681,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div id="modal1" className="modal open">
        <div className="modal-content">
          <div className="modal-title">
            {t("page.stations.stationDetails")} -{" "}
            <span>
              {station.code} ({station.name})
            </span>
          </div>
          <div className="row">
            <br />
            <div className="p0 col l6 m12 s12 overflow-auto">
              <table className="highlight datatable">
                <colgroup>
                  <col style={{ width: "35%" }} />
                  <col style={{ width: "65%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>{t("page.stations.startDate")}</th>
                    <td>{station.start_date.substring(0, 10)}</td>
                  </tr>
                  {station.end_date && (
                    <tr>
                      <th>{t("page.stations.endDate")}</th>
                      <td>{station.end_date.substring(0, 10)}</td>
                    </tr>
                  )}
                  <tr>
                    <th>{t("w.latitude")}</th>
                    <td>{station.latitude.toFixed(4)}</td>
                  </tr>
                  <tr>
                    <th>{t("w.longitude")}</th>
                    <td>{station.longitude.toFixed(4)}</td>
                  </tr>
                  <tr>
                    <th>{t("w.elevation")}</th>
                    <td>{station.elevation.toFixed(0)} m</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="p0 col l6 m12 s12">
              <table className="highlight datatable">
                <colgroup>
                  <col style={{ width: "35%" }} />
                  <col style={{ width: "65%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>{t("page.stations.installationType.title")}</th>
                    {/* <td>{station.stationType}</td> */}
                    <td>
                      {t(
                        "page.stations.installationType." + station.stationType
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t("page.stations.sensorTypes")}</th>
                    {/* <td>{station.sensorsInKorean.join(', ')}</td> */}
                    <td>
                      {station.sensors
                        .map((s) => t("sensorType." + s))
                        .join(", ")}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      {t("page.stations.siteClassification")}(V<sub>S30</sub>)
                    </th>
                    <td>
                      {station.site_class &&
                        station.site_class.vs30 &&
                        (station.site_class.vs30["Downhole test"]
                          ? `${station.site_class.vs30["Downhole test"]} (Downhole test)`
                          : Object.entries(station.site_class.vs30)
                              .map((entry) => `${entry[1]} (${entry[0]})`)
                              .join(", "))}
                    </td>
                  </tr>
                  <tr>
                    <th className="">
                      {t("page.stations.siteClassification")}(H&V
                      <sub>S,Soil</sub>)
                    </th>
                    <td className="">
                      {station.site_class &&
                        station.site_class.h_and_vs_soil &&
                        (station.site_class.h_and_vs_soil["Downhole test"]
                          ? `${station.site_class.h_and_vs_soil["Downhole test"]} (Downhole test)`
                          : Object.entries(station.site_class.h_and_vs_soil)
                              .map((entry) => `${entry[1]} (${entry[0]})`)
                              .join(", "))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="clearfix">
              <br />
            </div>
            <div className="col l6 m12 s12">
              <div className="txt_box">
                <span className="txt_title">
                  {t("page.stations.siteInformation.title")}
                </span>
                <div>
                  {station.siteInfoImageUrl && (
                    <img
                      style={{ cursor: "pointer" }}
                      className="width-auto"
                      alt="부지정보 이미지"
                      src={STATION_IMAGE_BASE_URL + station.siteInfoImageUrl}
                      onClick={(e) => {
                        window.open(e.target.src);
                      }}
                    />
                  )}
                  <span>※ {t("page.stations.siteInformation.desc")}</span>
                </div>
                <br />
              </div>
            </div>
            <div className="obser_modal_pic_container col l6 m12 s12">
              <div className="txt_box">
                <span className="txt_title">
                  {t("page.stations.stationPhotographs")}
                </span>
                <div className="row">
                  {station.images &&
                    station.images.map((imageObj) => (
                      <div className="col l6 m6 s12" key={imageObj.url}>
                        <img
                          style={{ cursor: "pointer", width: "100%" }}
                          src={STATION_IMAGE_BASE_URL + imageObj.thumbnailUrl}
                          alt={imageObj.title}
                          title={t("page.stations.photoImgTitle")}
                          onClick={(e) => {
                            window.open(STATION_IMAGE_BASE_URL + imageObj.url);
                          }}
                        />
                        <div className="well">
                          {t("w.dateTaken")}
                          {": "}
                          {imageObj.creationDate}
                        </div>
                      </div>
                    ))}
                  {/*<div className="col l6 m6 s12">
                    <img src="./images/_sample-img-4.jpg" alt="샘플이미지" style={{width:"100%"}} />
                    <div className="well">- 사진설명</div>
                  </div>
                  <div className="col l6 m6 s12">
                    <img src="./images/_sample-img-5.jpg" alt="샘플이미지" style={{width:"100%"}} />
                    <div className="well">- 사진설명</div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          className="modal-close waves-effect waves-green btn-flat"
          onClick={onClose}
        >
          <i className="ion ion-md-close"></i>
        </a>
      </div>
    </div>
  );
}
